import { ConcreteEncodable } from "./ConcreteEncodable";

import { ChangeHedgingModeEventImplEncoder } from "../../encoder/ChangeHedgingModeEventImplEncoder";

import * as CubiqTS from "../../index";
import { ChangeHedgingModeEvent } from "../ChangeHedgingModeEvent";

export class ChangeHedgingModeEventImpl
  extends ConcreteEncodable
  implements ChangeHedgingModeEvent
{
  public static enType: string = "com.bcdfx.model.event.lifecycle.ChangeHedgingModeEventImpl";

  /*FID=1*/
  public fixing: CubiqTS.BMTimeCode | null = null;
  /*FID=2*/
  public pairs: Array<string> | null = null;
  /*FID=3*/
  public userId: CubiqTS.Long | null = null;
  /*FID=4*/
  public hedgingModeType: CubiqTS.HedgingModeType;
  /*FID=100*/
  public messageId: string;
  public sessionOnly: string;

  constructor() {
    super();
    this.encoder = ChangeHedgingModeEventImplEncoder.Instance;
    this.setEncodableType(ChangeHedgingModeEventImpl.enType);
    //Model
  }

  public toString(): string {
    return (
      "ChangeHedgingModeEventImpl[" +
      "fixing=" +
      this.fixing +
      "pairs=" +
      this.pairs +
      "userId=" +
      this.userId +
      "hedgingModeType=" +
      this.hedgingModeType +
      "messageId=" +
      this.messageId +
      "]"
    );
  }

  public validateInbound(): void {}

  public validateOutbound(): void {}
}
